<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div ref="section">
    <div class="mainbox_one">
      <div class="mainbox_one_title">{{ menulist.name }}</div>
      <VueDraggable ref="el" v-model="cardDatas" @end="updateSortOrder" class="list-box card-row"
        :style="{ '--cols': cardCols }">
          <div
            class="card-cell"
            v-for="(cardData, index) in cardDatas"
            :key="index"
            :index="cardData.id"
          >
            <div>
              <el-link class="card-link" :href="cardData.url" :underline="false" target="_blank" @click.native="handleVisit(cardData)">
                <el-card
                  class="box_card"
                  shadow="hover"
                  :body-style="{ padding: '0px' }"
                >
                  <div class="card_header">
                    <el-dropdown placement="top-end">
                      <span @click.prevent>
                        <i class="el-icon-more"></i>
                      </span>

                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="editCardData(cardData)"
                          >修改</el-dropdown-item
                        >
                        <el-dropdown-item
                          @click.native="removeCard(cardData.id)"
                          >删除</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <el-image :src="cardData.logoImg" class="webimg">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-card>
              </el-link>

              <div class="card_name">
                <span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="cardData.content"
                    placement="bottom-start"
                    :disabled="!cardData.content"
                    popper-class="desc-tooltip"
                  >
                    <el-link target="_blank" :underline="false" :href="cardData.url" @click.native="handleVisit(cardData)">
                      {{ cardData.title }}
                    </el-link>
                  </el-tooltip>
                </span>
              </div>
            </div>
          </div>

          <div class="card-cell">
            <div>
            <el-button
              class="card_add"
              icon="el-icon-plus"
              @click="dialogFormVisible = true"
            ></el-button>
            <div class="card_name">
              <span @click="dialogFormVisible = true">添加</span>
            </div>
            </div>
          </div>
        </VueDraggable>
    </div>
    <!-- 添加卡片 -->
    <el-dialog
      :visible.sync="dialogFormVisible"
      width="83.333333%"
      top="0px"
      :modal="false"
      @closed="onDialogClosedFn"
    >
      <div class="dialog_box">
        <p>添加</p>

        <el-form
          :model="addCard"
          :rules="rulesAddCardRef"
          ref="addCardRef"
          label-width="158px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="网站地址" prop="url">
            <el-input
              v-model="addCard.url"
              placeholder="例如: https://www.zhancun.top"
            ></el-input>
            <el-button
              type="text"
              v-if="addCard.url"
              @click="fetchData"
              :loading="isLoading"
              >AI解析网址</el-button
            >
          </el-form-item>
          <el-form-item label="网站名称" prop="title">
            <el-input v-model="addCard.title"></el-input>
          </el-form-item>
          <el-form-item label="网站描述" prop="content">
            <el-input type="textarea" v-model="addCard.content"></el-input>
          </el-form-item>
          <el-form-item label="网站图标" prop="logoImg">
            <el-card
              class="box_card"
              shadow="never"
              :body-style="{ padding: '0px' }"
            >
              <el-image
                :src="addCard.logoImg"
                alt=""
                class="cover-img"
                ref="imgRef"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>

              <input
                type="file"
                style="display: none"
                accept="image/*"
                ref="iptFileRef"
                @change="onCoverChange"
              />
            </el-card>

            <el-button type="text" @click="chooseImgFn">+ 选择图片</el-button>
          </el-form-item>
        </el-form>
        <div class="dialog_box_btn">
          <el-button @click="onDialogClosedFn">取消</el-button>
          <el-button type="primary" @click="submitUpload(addCard)"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 修改卡片数据 -->
    <el-dialog
      title=""
      :visible.sync="dialogFormVisibleEdit"
      width="83.333333%"
      top="0px"
      :modal="false"
    >
      <div class="dialog_box">
        <p>修改</p>
        <el-form
          :model="editCard"
          ref="editCardRef"
          :rules="rulesAddCardRef"
          label-width="158px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="网站地址" prop="url">
            <el-input
              v-model="editCard.url"
              @focus="showButton = true"
            ></el-input
            ><el-button
              type="text"
              v-if="showButton"
              @click="editFetchData"
              :loading="isLoading"
              >AI解析网址</el-button
            >
          </el-form-item>
          <el-form-item label="网站名称" prop="title">
            <el-input v-model="editCard.title"></el-input>
          </el-form-item>
          <el-form-item label="网站描述" prop="content">
            <el-input type="textarea" v-model="editCard.content"></el-input>
          </el-form-item>
          <el-form-item label="网站分类" prop="categoryId">
            <el-select
              v-model="editCard.categoryId"
              placeholder="请选择分类"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="cate in categoryList"
                :key="cate.id"
                :label="cate.name"
                :value="cate.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网站图标" prop="imageUrl">
            <el-card
              class="box_card"
              shadow="never"
              :body-style="{ padding: '0px' }"
            >
              <el-image
                :src="editCard.logoImg"
                alt=""
                class="cover-img"
                ref="imgRef"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>

              <input
                type="file"
                style="display: none"
                accept="image/*"
                ref="iptFileRef"
                @change="onEditChange"
              />
            </el-card>

            <el-button type="text" @click="chooseImgFn">+ 选择图片</el-button>
          </el-form-item>
        </el-form>
        <div class="dialog_box_btn">
          <el-button @click="dialogFormVisibleEdit = false">取消</el-button>
          <el-button type="primary" @click="saveEditCardData()">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWebsiteListAPI,
  addWebsiteAPI,
  delWebsiteAPI,
  editWebsiteAPI,
  getWebsiteDataAPI,
  saveLayoutAPI,
  visitWebsiteAPI,
  getCategoryListAPI,
} from "@/api";
import { VueDraggable } from "vue-draggable-plus"; //拖拽网站的库
import { resolveLogoUrl, getLogoWithCache } from "@/utils/logo";

export default {
  components: {
    VueDraggable,
  },

  props: {
    menulist: {
      type: Object,
      required: true,
    },
  }, // 从home传过来的值

  data() {
    return {
      // 添加卡片数据
      isLoading: false,
      addCard: {
        url: "",
        title: "",
        content: "",
        logoImg: "",
        logoImgRaw: "", // 后端返回的原始 logo 值（相对路径），保存时使用
        logoImgUrl: null,
        categoryId: "",
      },
      cardDatas: [],
      // nextCardId: "",

      dialogFormVisible: false,
      dialogFormVisibleEdit: false,

      // 修改卡片数据

      editCard: {
        id: "",
        url: "",
        title: "",
        content: "",
        logoImgUrl: "", // 用于存储用户上传的文件
        logoImg: "",
        logoImgRaw: "", // 后端返回的原始 logo 值（相对路径），保存时使用
        categoryId: "", // 网站所属分类 id（修改弹窗的分类选择器）
      },

      categoryList: [], // 当前用户的分类列表（用于修改弹窗下拉选择）

      showButton: false, // 解析按钮是否显示

      rulesAddCardRef: {
        url: [
          { required: true, message: "请输入网址", trigger: "blur" },
          { type: "url", message: "请输入正确的网址", trigger: "blur" },
        ],
        title: [{ validator: this.validLength, trigger: "blur" }],
        content: [{ validator: this.validateContent, trigger: "blur" }],
      },
      cardCols: 6, // 一行卡片列数，按窗口宽度分档算出（1440→6 / 1920→8）
    };
  },

  created() {
    // 获取网站
    this.initWebsiteListFn();
    // 获取用户分类列表（修改弹窗的分类选择器用）
    this.initCategoryListFn();
    // 监听分类变动（有网站移到别的分类），实时刷新本分类列表，无需刷新页面
    this.$bus.$on("website-category-changed", this.initWebsiteListFn);
  },

  mounted() {
    // 列数依赖真实 DOM 宽度，必须在挂载后初始化
    this.setupCardCols();
  },

  beforeDestroy() {
    this.teardownCardCols();
    this.$bus.$off("website-category-changed", this.initWebsiteListFn);
  },

  methods: {
    /* ============ 响应式列数 ============
       按窗口宽度分档：1440 屏 6 列、1920 屏 8 列；下限夹在 6（一行最少 6 个、最多 8 个）。
       卡片区宽度由 .main-content 唯一基准 968px 决定（= banner 968×200 的宽度），
       列宽固定 88px、列间距靠 grid 的 space-between 摊出来。
       ▲ 这里的两个分档点必须与 Home.vue 里 .main-content 的 --cols 媒体查询一致 ——
         容器宽度跟着列数走（6 列 968 / 7 列 1144 / 8 列 1320），才能让列间距恒为 88px。 */
    setupCardCols() {
      this.cardCols = this.getCardCols();
      window.addEventListener("resize", this.handleResize);
    },

    teardownCardCols() {
      window.removeEventListener("resize", this.handleResize);
    },

    // 08-13 定稿方案的分档（1440 屏 6 列 / 1920 屏 8 列），下限夹到 6
    getCardCols() {
      const t = window.innerWidth;
      return t >= 1800 ? 8 : t >= 1600 ? 7 : 6;
    },

    handleResize() {
      this.cardCols = this.getCardCols();
    },

    scrollTo() {
      this.$refs.section.scrollIntoView({ behavior: "smooth" });
    },

    // 记录访问:用户点击分类中的网站后,该网站进入"最近去过的村子"
    handleVisit(cardData) {
      if (!cardData || !cardData.url) return;
      visitWebsiteAPI({
        url: cardData.url,
        title: cardData.title,
        content: cardData.content,
        logoImg: cardData.logoImgRaw || cardData.logoImg,
      })
        .then(() => {
          // 记录成功后,通知"最近去过的村子"实时刷新
          this.$bus.$emit("recent-visit");
        })
        .catch(() => {
          // 记录访问失败不影响跳转,静默忽略
        });
    },

    // 校验字符长度的方法
    validLength(rule, value, callback) {
      function getStrLength(str) {
        return str.replace(/[^\x00-\xff]/g, "xxx").length;
      }
      if (!value) {
        callback(new Error("输入不能为空"));
      } else if (getStrLength(value) < 1) {
        callback(new Error("不能少于 1 个字符"));
      } else if (getStrLength(value) > 24) {
        callback(new Error("中文1-8个汉字 (英文1-24)"));
      } else {
        callback();
      }
    },

    // 校验网站简介长度:最多 100 个汉字(英文 3 字符折算 1 个汉字,即 300 字符)
    validateContent(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      // 非 ASCII(中文)按 3 字符计,ASCII(英文)按 1 计;100 汉字 = 300
      const len = value.replace(/[^\x00-\xff]/g, "xxx").length;
      if (len > 300) {
        callback(new Error("简介最多 100 个汉字(英文 300 个字符)"));
      } else {
        callback();
      }
    },

    // 获取用户分类列表（修改弹窗的分类选择器用）
    async initCategoryListFn() {
      try {
        const userId = this.menulist.user_id || this.menulist.userId;
        const res = await getCategoryListAPI(userId);
        if (res.data && res.data.data) {
          this.categoryList = res.data.data;
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
      }
    },

    // 获取网站
    async initWebsiteListFn() {
      try {
        const categoryId = this.menulist.id;
        const res = await getWebsiteListAPI(categoryId);

        if (res.data && res.data.data) {
          this.cardDatas = res.data.data.map((card) => {
            // 优先使用 localStorage 中的 dataURL 缓存（相对路径 logo），避免每次刷新重新请求图片
            const logoImg = getLogoWithCache(card.logoImg, this.$backurl);
            return {
              ...card,
              logoImg,
              logoImgRaw: card.logoImg, // 保留原始相对路径,记录访问时使用
            };
          });

          // console.log('Card data:', this.cardDatas); // 打印数据以调试
        } else {
          console.error("Error: Unexpected API response", res);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    //解析网站数据的方法
    async fetchData() {
      try {
        this.isLoading = true;
        const url = this.addCard.url;
        const res = await getWebsiteDataAPI(url);
        const data = res.data;
        // 原始值（可能是相对路径 uploads/...）单独保存，用于写入数据库；
        // logoImg 拼接后端地址后仅用于弹窗预览显示
        const rawLogoImg = data.logoImg || '';
        this.addCard = { ...data, logoImgRaw: rawLogoImg };
        this.addCard.logoImg = resolveLogoUrl(rawLogoImg, this.$backurl);
        console.log(res);
      } catch (error) {
        console.error(error);
        // 如果发生错误，你可以在这里处理，例如显示一个错误消息
        this.$message.error("获取网站数据失败 请自己添加");
      } finally {
        this.isLoading = false;
      }
    },

    // 选择图片的弹窗事件方法
    chooseImgFn() {
      this.$refs.iptFileRef.click();
    },

    // 选择了上传的图片
    onCoverChange(e) {
      // 获取到用户选择的封面
      const file = e.target.files[0];
      if (file) {
        // 空文件会产生 data:, 这种无效 data URL，直接拒绝
        if (file.size === 0) {
          this.$message.error("图片内容为空，请重新选择");
          return;
        }
        // 检查文件大小
        const maxSize = 50 * 1024; // 50KB
        if (file.size > maxSize) {
          this.$message.error("图片大小超过50kb!");
          return;
        }

        // 创建一个FileReader来读取文件
        const reader = new FileReader();
        reader.onload = (e) => {
          // 创建一个Image来获取图片尺寸
          const img = new Image();
          img.onload = () => {
            // 检查图片尺寸
            const maxDimension = 500; // 500px
            if (img.width > maxDimension || img.height > maxDimension) {
              this.$message.error("图片尺寸超过500px!");
              return;
            }

            // 如果文件大小和尺寸都符合要求，那么可以进行上传操作
            this.addCard.logoImgUrl = file;
            this.addCard.logoImg = URL.createObjectURL(file);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    //添加网站的方法
    submitUpload() {
      this.$refs.addCardRef.validate(async (valid) => {
        if (!valid) return;

        const categoryId = this.menulist.id;

        const formData = new FormData();
        formData.append("title", this.addCard.title);
        formData.append("content", this.addCard.content);
        formData.append("url", this.addCard.url);

        // 判断logoImgUrl是文件还是链接
        if (this.addCard.logoImgUrl instanceof File) {
          // 如果是文件，添加到表单
          formData.append("logoImg", this.addCard.logoImgUrl);
        } else if (typeof this.addCard.logoImg === "string") {
          // 优先保存原始值（相对路径），避免把带本机地址的完整 URL 写进数据库；
          // 空 data URL（data:,）说明没有有效 logo，不提交
          const logoValue = this.addCard.logoImgRaw || this.addCard.logoImg;
          if (logoValue && logoValue !== 'data:,') {
            formData.append("logoImg", logoValue);
          }
        }
        // 打印 FormData 内容，检查是否包含文件
        // for (const pair of formData.entries()) {
        //   console.log(`${pair[0]}: ${pair[1]}`);
        // }
        try {
          const { data: res } = await addWebsiteAPI({ formData, categoryId });
          if (res.status !== 0) {
            this.$message.error(res.message || '添加失败');
            return;
          }
          await this.initWebsiteListFn();
          this.dialogFormVisible = false;
        } catch (error) {
          console.error('添加失败:', error);
          this.$message.error('添加失败，请重试');
        }
      });
    },

    
    // 对话框完全关闭之后的处理函数
    onDialogClosedFn() {
      // 清空关键数据
      this.$refs.addCardRef.resetFields();
      // 因为这2个变量对应的标签不是表单绑定的, 所以需要单独控制

      // this.$refs.imgRef.setAttribute('src', null)
      this.dialogFormVisible = false;
    },

    // 显示修改的卡片数据
    async editCardData(cardData, index) {
      this.editCard.id = cardData.id;
      this.editCard.url = cardData.url;
      this.editCard.title = cardData.title;
      this.editCard.content = cardData.content;
      this.editCard.logoImg = cardData.logoImg;
      this.editCard.logoImgRaw = ""; // 清空上次解析的原始值，避免误存到其他卡片
      this.editCard.categoryId = cardData.category_id; // 回显当前所属分类
      this.dialogFormVisibleEdit = true;

      console.log(this.editCard);
    },


    onEditChange(e) {
      // 获取到用户选择的封面
      const file = e.target.files[0];
      if (file) {
        // 空文件会产生 data:, 这种无效 data URL，直接拒绝
        if (file.size === 0) {
          this.$message.error("图片内容为空，请重新选择");
          return;
        }
        // 检查文件大小
        const maxSize = 50 * 1024; // 50KB
        if (file.size > maxSize) {
          this.$message.error("图片大小超过50kb!");
          return;
        }

        // 创建一个FileReader来读取文件
        const reader = new FileReader();
        reader.onload = (e) => {
          // 创建一个Image来获取图片尺寸
          const img = new Image();
          img.onload = () => {
            // 检查图片尺寸
            const maxDimension = 500; // 500px
            if (img.width > maxDimension || img.height > maxDimension) {
              this.$message.error("图片尺寸超过500px!");
              return;
            }

            // 如果文件大小和尺寸都符合要求，那么可以进行上传操作
            this.editCard.logoImgUrl = file;
            this.editCard.logoImg = URL.createObjectURL(file);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.editCard.logoImgUrl = this.editCard.logoImg;
      }
    },

    // 编辑输入网址获取该网站标题简介和logo数据
    async editFetchData() {
      try {
        this.isLoading = true;
        const url = this.editCard.url;
        const res = await getWebsiteDataAPI(url);

        // 只更新特定的字段
        const rawLogoImg = res.data.logoImg || '';
        this.editCard.logoImgRaw = rawLogoImg;
        this.editCard.title = res.data.title;
        this.editCard.content = res.data.content;
        // logoImg 拼接后端地址后仅用于弹窗预览显示
        this.editCard.logoImg = resolveLogoUrl(rawLogoImg, this.$backurl);
      } catch (error) {
        console.error(error);
        // 如果发生错误，你可以在这里处理，例如显示一个错误消息
        this.$message.error("获取网站数据失败 请自己添加");
      } finally {
        this.isLoading = false;
      }
    },

    // 保存修改的数据
    saveEditCardData() {
      this.$refs.editCardRef.validate(async (valid) => {
        if (!valid) return;
        // 通过校验
        // console.log(this.editCard)
        const formData = new FormData();
        formData.append("id", this.editCard.id);
        formData.append("title", this.editCard.title);
        formData.append("content", this.editCard.content);
        formData.append("url", this.editCard.url);
        // 选择了新分类才提交，否则保持原分类不变
        if (this.editCard.categoryId) {
          formData.append("category_id", this.editCard.categoryId);
        }

        // formData.append('logoImg', this.editCard.logoImgUrl)

        // 判断logoImgUrl是文件还是链接
        if (this.editCard.logoImgUrl instanceof File) {
          // 如果是文件，添加到表单
          formData.append("logoImg", this.editCard.logoImgUrl);
        } else if (typeof this.editCard.logoImg === "string") {
          // 优先保存原始值（相对路径），避免把带本机地址的完整 URL 写进数据库；
          // 空 data URL（data:,）说明没有有效 logo，不提交
          const logoValue = this.editCard.logoImgRaw || this.editCard.logoImg;
          if (logoValue && logoValue !== 'data:,') {
            formData.append("logoImg", logoValue);
          }
        }

        // //查看formdata发送的数据
        // for (const pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }
        try {
          const { data: res } = await editWebsiteAPI(formData);
          if (res.status !== 0) return this.$message.error(res.message || '保存失败');
          // 通知所有分类刷新列表（移入和移出的分类都立即更新，无需刷新页面）
          this.$bus.$emit("website-category-changed");
          this.showButton = false;
          this.dialogFormVisibleEdit = false;
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败，请重试');
        }
      });
    },


    cancelEdit() {
      this.showButton = false;
      this.dialogFormVisibleEdit = false;
      this.addCard = {};
    },

    // 删除卡片
   

    async removeCard(id) {
      // console.log(id)
      // 执行删除的操作
      // this.cardDatas.splice(this.cardDatas.indexOf(id), 1)
      const res = await delWebsiteAPI(id);
      console.log(res);
      // if (res.code !== 0) return this.$message.error('删除失败!')
      // this.$message.success('删除成功!')

      // 刷新列表数据
      this.initWebsiteListFn();
    },

    //拖拽网站卡片位置  2024.9.27 下午 【。】
    async updateSortOrder() {
      const updates = this.cardDatas.map((item, index) => ({
        id: item.id,
        sort_order: index + 1,
        category_id: item.category_id,
      }));

      // console.log(updates); // 打印更新数据以确认格式

      try {
        await saveLayoutAPI(updates); // 调用 API
        // this.$message.success('排序更新成功！'); // 提示用户
      } catch (error) {
        this.$message.error("更新排序失败！"); // 错误处理
        console.error("更新失败:", error); // 打印错误以便调试
      }
    },
  },
};
</script>

<style scoped>
.mainbox_one {
  height: auto;
  /* margin-block-end: 42px; */
  padding-top: 32px;
  max-width: 100%; /* 宽度跟随上层 .main-content（唯一基准 968px），不再自己限宽 */
  margin: 0 auto;    /* 居中 → 标题、卡片、banner 三者左右缘对齐 */
}

.mainbox_one_title {
  width: 170px;
  height: 33px;
  padding-block-end: 18px;
  font-size: 24px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 33px;

  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏超出容器的文本 */
  text-overflow: ellipsis;
  /* 将超出的文本显示为省略号 */
}

/* 卡片行：固定 88px 列 + space-between 把余量摊成列间距。
   间距恒 88px 是由 .main-content 的宽度保证的（Home.vue：宽度 = 列数×88 + (列数−1)×88，
   6 列 968 / 7 列 1144 / 8 列 1320）—— 容器宽正好时余量 ÷ (列数−1) 恰好 = 88。
   所以这里既不要写 column-gap，也不要动 minmax 的 88px 上限，否则间距会失准。
   首列贴容器左缘、末列贴容器右缘 ↔ 与 banner 天然对齐。
   minmax(0, 88px)：常规宽度下每列就是 88px；窗口窄到放不下 cols×88 时才让列收窄
   （列数下限 6，见 getCardCols），这样固定 88px 也不会在窄屏横向溢出。 */
.card-row {
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(0, 88px));
  justify-content: space-between;
  row-gap: 24px;
}

.card-cell > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 卡片外层链接块级,避免行内 <a> 影响布局 */
.card-cell .card-link {
  display: block;
  width: 100%;
}

/* 卡片 88×88：外框 = 栅格列宽，而列宽上限就是 88px，
   所以常规窗口（内容区 ≥ 6×88）下渲染出来正好 88×88；
   box-sizing:border-box = 内描边：边框画在 88 内部，外框正好 88，与 grid 列宽一致
   （Element 的 .el-card 默认 content-box，不写这句外框会变成 90、首尾错位 2px） */
.card-cell .box_card {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  background-color: rgb(255, 255, 255);
}

/* 卡片内部水平垂直居中 */
.card-cell .box_card ::v-deep .el-card__body {
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.webimg {
  width: 32px;
  height: 32px;
  display: block;
}

.card_header {
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  z-index: 2;
}

.el-card:hover .card_header {
  opacity: 1;
}

.el-icon-more {
  color: #666;
  transform: rotate(90deg);
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
}

/* 更多按钮悬停：颜色加深并轻微放大（保留 90° 旋转） */
.el-icon-more:hover {
  color: #333333;
  transform: rotate(90deg) scale(1.2);
}

/* 添加按钮：与卡片同尺寸、同样内描边（跟随列宽，列宽上限 88px） */
.card-cell .card_add {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 12px;
  width: 100%;
  aspect-ratio: 1 / 1;
  margin: 0;
  padding: 0;
  font-size: 28px;
  color: #8c939d;
  transition: all 0.2s;
}

/* 添加按钮悬停效果:虚线变实线主题色、图标与背景变色 */
.card-cell .card_add:hover {
  border-color: #ff4d90;
  border-style: solid;
  color: #ff4d90;
  background-color: #fff0f5;
}

.card-cell .card_name {
  text-align: center;
  width: 100%;
  height: 20px;
  font-size: 14px;

  font-weight: 400;
  color: #333;
  line-height: 20px;
  margin-top: 8px;
  margin-right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-link.el-link--default {
  color: #1d1d1f;
}

.cover-img {
  width: 32px;
  height: 32px;
  display: block;
  margin: 0 auto;
  /* object-fit: cover; */
}

.el-icon-picture-outline {
  font-size: 32px;
  color: #eeeeee;
}

/* 弹窗(添加/修改)里的网站图标框:88×88 正方形(内描边),图标居中 */
.dialog_box .box_card {
  box-sizing: border-box;
  width: 88px;
  height: 88px;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  background-color: rgb(255, 255, 255);
}

.dialog_box .box_card ::v-deep .el-card__body {
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
